import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { api, call } from '@/lib/api';
import { qk } from '@/lib/query-keys';

export const ME_QUERY_KEY = qk.me;

export const meQueryOptions = () =>
  queryOptions({
    queryKey: qk.me,
    queryFn: () => call(api.me.$get()),
    staleTime: 60_000,
  });

/** Session applicative (`GET /me`), garantie par le `beforeLoad` de la route `_auth`. */
export function useSession() {
  const { data: me } = useSuspenseQuery(meQueryOptions());
  return { me, user: me.user, settings: me.settings, isAdmin: me.user.role === 'admin' };
}
